import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { OuiIconModule } from 'omnium-ui/icon';

@Component({
  selector: 'app-qpi-icon-box',
  imports: [OuiIconModule],
  templateUrl: './qpi-icon-box.component.html',
  styleUrl: './qpi-icon-box.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.incomplete]': '!completed()',
    '[class.ignored]': 'ignored()',
  },
})
export class QpiIconBoxComponent {
  readonly icon = input.required<string>();
  readonly completed = input.required<boolean>();
  readonly ignored = input<boolean>(false);
}
